import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import FormikForm from './form/Formik';
import FormData from './formData.json';
import { FormEntityProps } from '@shared/types';
import { getRootId } from '@shared/utils';

const { data, rootIdName } = getRootId(FormData as FormEntityProps);

// Renders the form layout in the React root div with a dynamic or default root div id.
// Passes form data from formData.json to Layout App.
const root = ReactDOM.createRoot(
  document.getElementById(rootIdName) as HTMLElement,
);

root.render(
  <React.StrictMode>
    <FormikForm {...data} />
  </React.StrictMode>,
);
